import classNames from 'classnames';
const _InputStatuses = ['warning', 'error', ''];
export function getStatusClassNames(prefixCls, status, hasFeedback) {
  return classNames({
    [`${prefixCls}-status-success`]: status === 'success',
    [`${prefixCls}-status-warning`]: status === 'warning',
    [`${prefixCls}-status-error`]: status === 'error',
    [`${prefixCls}-status-validating`]: status === 'validating',
    [`${prefixCls}-has-feedback`]: hasFeedback
  });
}
export const getMergedStatus = (contextStatus, customStatus) => customStatus || contextStatus;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/statusUtils.js
// module id = 85
// module chunks = 0